import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { StyledButton } from "@insite/mobius/Clickable";
import { FormInputWrapper } from "@insite/mobius/FormField";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { IconWrapper } from "@insite/mobius/Icon";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import * as React from "react";
import { css } from "styled-components";
import styled from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    logoMobileWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    menuBarWrapper?: InjectableCss;
    signInWrapper?: InjectableCss;
    branchWrapper?: InjectableCss;
    cartWrapper?: InjectableCss;
    rightsideLinks?: InjectableCss;
    rewardsWrapper?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1470px;
            margin: 0 auto;
            padding: 0rem 15px;
        `,
    },
    logoWrapper: {
        css: css`
            width: 95px;
            min-width: 95px;
            height: 95px !important;
            padding: 0 !important;
            min-height: 95px;
            float: left;
            position: relative;
            margin-top: -35px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 30px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            * {
                max-height: 95px;
            }
            a {
                > span {
                    width: 95px;
                    height: inherit;
                    ${({ theme }) => { return breakpointMediaQueries(
                        theme, [
                        null, 
                        null,
                        null, 
                        css` 
                            z-index: 1;
                        `,],"min",); 
                    }}
                    > img {
                        height: 95px;
                    }
                }
            }
        `,
    },
    logoMobileWrapper: {
        css: css`
            display: flex;
            align-items: center;
            text-align: left;
            padding: 0px;
            margin: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: 78px;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            float: left;
            width: auto;
            display: flex;
            position: relative;
            padding: 0;
            margin: 0 15px;
            min-width: initial;
            flex: auto;
            margin-bottom: 1px;            
            > div[class^="Wrapper"] {
                display: flex;
            }
            &.search-wrap > div > div {
                width: 100%;
                height: 40px;
                margin-top: 5px;                              
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-right: 15px;
                        margin-right: 0px;
                        border-right: 1px solid ${ADIColors.gray3};
                    `,
                    css`
                        padding-right: 15px;
                        margin-right: 0px;
                        border-right: 1px solid ${ADIColors.gray3};
                    `,
                    css`
                        max-width: 300px;
                        width: 100%;
                        margin: 0 15px;
                    `,
                    css`
                        max-width: 300px;
                        width: 100%;
                        margin: 0 15px;
                    `,
                    css`
                        margin: 0 30px;
                    `,
                ]);
            }}
        `,
    },
    menuBarWrapper: {
        css: css`
            display: flex;
            align-items: center;
            margin-top: 0;
            max-width: max-content;
            min-width: max-content;
            > div[class^="Wrapper"] {
                display: flex;
                height: 100%;
                > div[class^="sc"] {
                    display: flex;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [null, null, null, null, null], "max");
            }}
        `,
    },
    signInWrapper: {
        css: css`
            margin: auto 0;
            background-color: transparent;
            height: 34px;
            width: auto;
            border-radius: 0;
            text-align: center;
            border-right: 1px solid #dddddd; // color is not present in style guide
            float: left;
            display: flex;
            align-items: center;
            padding: 0 15px 0 0;
            position: relative;
            height: 40px;

            > div[class^="Wrapper"] {
                display: flex;
                align-items: center;
                height: 100%;
                > div[class^="sc"] {
                    display: flex;
                    > ${StyledButton} {
                        > ${IconWrapper} {
                            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                            color: ${getColor("common.background")};
                                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
                        }
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [null, null, null, null, null], "max");
            }}
        `,
    },
    cartWrapper: {
        css: css`
            display: flex;
            align-items: center;

            float: left;
            background-color: transparent;
            min-height: 25px;
            height: auto;
            width: auto;
            border-radius: 0;
            text-align: center;
            margin: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-left: 8px;
                        `,
                        css`
                            margin-left: 8px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    branchWrapper: {
        css: css`
            float: left;
            margin: 0px 17px 0px 10px;
            padding: 0;
            background-color: transparent;
            min-height: 25px;            
            max-height: 40px;
            height: auto;
            width: auto;
            border-radius: 0;
            text-align: center;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    css`
                        max-height:27px;
                    `,
                    css`
                        max-height:27px;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    rewardsWrapper: {
        css: css`
            float: left;
            margin: 0px 0px 0px 10px;
            padding: 0;
            background-color: transparent;
            width: auto;
            border-radius: 0;
            text-align: center;
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    rightsideLinks: {
        css: css`
            position: relative;
            display: flex;
            height: auto;
            justify-content: flex-end;
            display: flex;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        width: 41%;
                        width: auto;
                        margin: auto;
                        display: flex;
                        align-items: center;
                        margin-right: 0;
                        max-width: initial;
                    `,
                    css`
                        width: 55%;
                    `,
                    css`
                        width: 25%;
                        height: 40px;
                    `,
                ]);
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <Hidden below="lg">
            <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
        </Hidden>
        <Hidden above="sm">
            <StyledWrapper {...logoLinksSearchStyles.logoMobileWrapper}>
                <Zone contentId={id} zoneName="MobileLogo" />
            </StyledWrapper>
        </Hidden>
        <StyledWrapper {...logoLinksSearchStyles.menuBarWrapper}>
            <Zone contentId={id} zoneName="MenuBar" />
        </StyledWrapper>
        <StyledWrapper className="search-wrap" {...logoLinksSearchStyles.searchMenuWrapper}>
            <Zone contentId={id} zoneName="Search" />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.rightsideLinks}>
            <Hidden below="md">
                <StyledWrapper {...logoLinksSearchStyles.signInWrapper}>
                    <Zone contentId={id} zoneName="SignIn" />
                </StyledWrapper>
            </Hidden>

            <StyledWrapper {...logoLinksSearchStyles.rewardsWrapper}>
                <Zone contentId={id} zoneName="Rewards" />
            </StyledWrapper>

            <Hidden below="md">
                <StyledWrapper {...logoLinksSearchStyles.branchWrapper}>
                    <Zone contentId={id} zoneName="Branch" />
                </StyledWrapper>
            </Hidden>
            <StyledWrapper {...logoLinksSearchStyles.cartWrapper}>
                <Zone contentId={id} zoneName="Cart" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
